import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, NEVER, tap } from 'rxjs';
import { ScimService } from '../../services';
import { ScimActions } from '../actions';
import { OperationsTrackerService } from '@anecdotes/shared-infra';

@Injectable()
export class ScimEffects {
  constructor(
    private actions$: Actions,
    private scimService: ScimService,
    private operationsTrackerService: OperationsTrackerService
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScimActions.Load),
      mergeMap(() => this.scimService.getScimApiKeys()),
      map((apiKeys) => ScimActions.Loaded({ apiKeys }))
    )
  );

  generate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScimActions.Generate),
      mergeMap((action) => this.scimService.generateScimApiKey(action.keyName)),
      tap((scimApiKey) => this.operationsTrackerService.trackSuccessWithData(ScimActions.Generate.type, scimApiKey)),
      catchError((err) => {
        this.operationsTrackerService.trackError(ScimActions.Generate.type, err);
        return NEVER;
      }),
      map((apiKey) => {
        return {
          ...apiKey,
          key: apiKey.key.substring(apiKey.key.length - 8) // clip api key value in order to not to keep full value in store
        };
      }),
      map((apiKey) => ScimActions.Generated({ apiKey }))
    )
  );

  revoke$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScimActions.Revoke),
      mergeMap((action) => this.scimService.revokeScimApiKey(action.apiKeyId).pipe(map(() => action.apiKeyId))),
      tap(() => this.operationsTrackerService.trackSuccess(ScimActions.Revoke.type)),
      catchError((err) => {
        this.operationsTrackerService.trackError(ScimActions.Revoke.type, err);
        return NEVER;
      }),
      map((apiKeyId) => ScimActions.Revoked({ apiKeyId }))
    )
  );
}
